import "./Share.css";
import { useState, useEffect, useContext } from "react";
import ReactLoading from 'react-loading';
import React from "react";
import Gift from "../../components/post/Gift";
import CurrencyList from "../../components/post/CurrencyList";
import { IoIosArrowDropdown } from "react-icons/io";
import SelectedItemDetails from "./SelectedItemDetails";
import SelectedCurrencyDetails from "./SelectedCurrencyDetails";
import SharePostModal from "../../components/post/sharepost/SharePostModal";
import config from "../../config";
import axios from "axios";
import Popup from "../../components/popup/Popup";
import { AuthContext } from "../../context/AuthContext";
import propTypes from "prop-types";
import ImageProcessor from "../../components/imageProcessor/ImageProcessor";
// import useLinkGenerator from "./LinkGenerator";
// import config from "../../config";

export default function Share({setIsAccountBalanceModalOpen, setShowTopbar}) {
  const { user, balance } = useContext(AuthContext);
  const [totalCost, setTotalCost] = useState(0);
  // default gift and type dropdowns
  const [transactionType, setTransactionType] = useState("");
  const [selectionType, setSelectionType] = useState("");
  // used to set each dropdown to open or closed
  const [giftDropdownOpen, setGiftDropdownOpen] = useState(false);
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  // used in the dropdown setting items
  const [defaultGiftText, setDefaultGiftText] = useState("Select Gift");
  const [defaultTypeText, setDefaultTypeText] = useState("Select Type");
  const [hasLink, setHasLink] = useState();
  const [isLoading, setIsLoading] = useState(true); 
  // cost [linkGenerated, setLinkGenerated] = useState(false);
  // const [generatedLink, setGeneratedLink] = useState(null);
  // const generateLink = useLinkGenerator();
  
  // share post logic
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [details, setDetails] = useState(null);

  // used in the slider for allowing gifts
  // const [allowGifts, setAllowGifts] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  // used for ImageProcessor
  const [triggerImageProcessor, setTriggerImageProcessor] = useState(false);
  const [isDoneProcessing, setIsDoneProcessing] = useState(false);

  // used to process and cache images for SharePostModal.jsx
  // const { sendHtmlToServer } = useImageHandling(user.username);

  // function to show popup used in the catch blocks
  const popupStatus = async (message) => {
    setPopupMessage(message);
    setShowPopup(true);
  };


  // fetch if user has a link
  useEffect(() => {
    if (user && user._id) {
      try {
        fetchActiveLinks();
      } catch (error) {
        console.error("error fetching links for user");
      }
    }
  }, [])

  const fetchActiveLinks = async () => {
    const response = await axios.get(`${config.apiUrl}/links/active-links/${user.username}`);
    console.log("response: ", response.data.totalLinks);
    if(response.data.totalLinks > 0){
      setHasLink(true);
    } else {
      console.log("toatlLinks < 0")
      setHasLink(false);
    }
    setIsLoading(false);
  };
    
  // used in the settings form
  const handleSubmit = async (e) => {
    // Prevent default form submission behavior
    e.preventDefault();
    if (transactionType && selectionType && (selectedItem || selectedAmount)) {
      console.log("handel submit...");
      // render images, process for server
      setTriggerImageProcessor(true);
      setIsDoneProcessing(false);

      // Ensure user has selected a quantity when giving currency
      if (
        transactionType === "Give" &&
        selectionType === "Currency" &&
        quantity === ""
      ) {
        popupStatus(
          "Please enter how many times this link can be used",
          "Close"
        );
        return;
      }

      // update link details
      const linkDetails = updateDetails();
      setDetails(linkDetails);
      setIsModalOpen(true);
    }
  };

  // resets details on selection type
  useEffect(() => {
    setDetails(null);
    setSelectedAmount(null);
    setSelectedItem(null);
  }, [selectionType]);

  // use state for currency amounts popup
  const [seenGifts, setseenGifts] = useState(false);
  const [seenMoney, setSeenMoney] = useState(false);

  // function for gift item popup
  const toggleGift = () => {
    if (!seenGifts) {
      setseenGifts(!seenGifts);
      setSeenMoney(false); // Hide the other component
    }
  };

  // function for give currency popup
  const toggleAmounts = () => {
    if (!seenMoney) {
      setSeenMoney(!seenMoney);
      setseenGifts(false); // Hide the other component
    } else if (seenMoney) {
      setSeenMoney(false);
    }
  };

  /* SELECTED ITEM HANDLING LOGIC BELOW */
  // used for the selected item
  const [selectedItem, setSelectedItem] = useState(null);
  const [showItem, setShowItem] = useState(false);

  /* CURRENCY AMOUNT HANDLING LOGIC BELOW */
  // used for the selected currency amount
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [showCurrency, setShowCurrency] = useState(false);
  const [quantity, setQuantity] = useState("");

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowItem(true);
    setseenGifts(false); // used to hide the item list when a selection is made
    setSelectedAmount(null);
  };

  // used for exiting the item
  const clearSelectedItem = () => {
    setTotalCost(0);
    setSelectedItem(null);
    setShowItem(false);
    setseenGifts(true); // used to hide the item list when a selection is made
  };

  const handleCurrencyClick = (amount) => {
    setSelectedAmount(amount);
    setShowCurrency(true);
    setSeenMoney(false); // used to hide the currency list when a selection is made
    setseenGifts(false); // used to hide the item list when a selection is made
    setSelectedItem(null);
  };

  // used for exiting the currency amount
  const clearSelectedCurrency = () => {
    setTotalCost(0);
    setSelectedAmount(null);
    setShowCurrency(false);
    setSeenMoney(true);
    setseenGifts(false);
  };

  // used to set the details of the link model
  // used in the link generator component
  // used in the selected item details component
  const updateDetails = () => {
    let newDetails = {
      type: selectionType.toLowerCase(),
      amount: null,
      giveorreceive: transactionType.toLowerCase(),
      remainingQuantity: null,
      initialQuantity: null,
      title: null,
      photo: null,
      itemId: null,
      // totalCost used in the create/add funds button below
      totalCost: null
    };

    // If it's a currency, update the amount and set the other fields to null
    if (selectionType === "Currency") {
      newDetails.amount = selectedAmount;
      newDetails.initialQuantity = quantity || 1;
      newDetails.remainingQuantity = quantity || 1;
      newDetails.title = null;
      newDetails.photo = null;
      newDetails.itemId = null;
      newDetails.totalCost = selectedAmount * quantity;
    }

    // If it's an item, update the title, photo, and itemId
    if (selectionType === "Item") {
      let itemAmount = 0;

      if (selectedItem.price) {
        itemAmount += Number(selectedItem.price);
      }

      if (
        selectedItem.shippingOptions &&
        selectedItem.shippingOptions.length > 0
      ) {
        itemAmount += Number(
          selectedItem.shippingOptions[0].shippingCost.value
        );
      }

      newDetails.amount = itemAmount;
      newDetails.initialQuantity = 1;
      newDetails.remainingQuantity = 1;
      newDetails.title = selectedItem.name;
      newDetails.photo = selectedItem.imageUrl;
      newDetails.itemId = selectedItem?.itemId || null;
      newDetails.totalCost = itemAmount
    }
    return newDetails;
  };

  // hook used for displaying create/add funds button conditinally
  useEffect(() => {
    let cost;
    // if giving item
    if (selectedItem && transactionType === "Give"){
      // TODO: figure out what to do for calculated shipping, item gives :|
      if (typeof selectedItem.shippingPrice === "string") {
        cost = selectedItem.price;
      } else if (typeof selectedItem.shippingPrice === "number") {
        cost = selectedItem.price + selectedItem.shippingPrice;
      }

      // else if giving currency
    } else if (selectedAmount && quantity && transactionType === "Give"){
      cost = quantity * selectedAmount;
    }
    setTotalCost(cost);
  }, [quantity, selectedAmount, selectedItem])

  // open topbar, and account balance modal
  // not enough funds to give gift
  const goToAddFunds = () => {
    setIsAccountBalanceModalOpen(true);
    setShowTopbar(false);
  };
  
  const handleProcessingComplete = () => {
    console.log("Processing complete, resetting trigger...");
    setTriggerImageProcessor(false); // Reset the trigger
    setIsDoneProcessing(true); // Mark processing as done
  };

  useEffect(() => {
    if(isDoneProcessing){
      console.log("done processing, setting trigger back to false");
    }
  },[isDoneProcessing])

  if(isLoading){
    return (
      <>
      <div className="no-link-container">
          <ReactLoading type={'balls'} color={'white'} height={'20%'} width={'20%'} />
          </div>
          </>
    )
  }

  return (
    <div className="share">
      <Popup
        isPopupOpen={showPopup}
        message={popupMessage}
        button1Text="Close"
        button1Action={() => setShowPopup(false)}
      />
      {hasLink ? (
      <>
      <div className="no-link-container">
          <p>You already have an active link. Come back here later after your link is used or expired in 24 hours.</p>
          </div>
          </>
      ) : (
        <>
      <div className="createLinkWrapper">
        <div className="top-card">
          <div className="linkOptions">
            <div className="shareTop"></div>
          </div>

          <div className="gift-selected-item">
            {seenGifts && <Gift onItemClick={handleItemClick} />}
            {showItem && !seenGifts && !seenMoney && (
              <SelectedItemDetails
                item={selectedItem}
                clearSelectedItem={clearSelectedItem}
              />
            )}

            {seenMoney && <CurrencyList onAmountClick={handleCurrencyClick} />}
            {showCurrency && !seenGifts && !seenMoney && (
              <SelectedCurrencyDetails
                amount={selectedAmount}
                giveorreceive={transactionType}
                clearSelectedCurrency={clearSelectedCurrency}
              />
            )}
          </div>
          <div className="settings-form-container">
            <form className="settingsForm" onSubmit={handleSubmit}>
              <div className="radioContainer">
                <div className="left-side-settings">
                  <div className="giveOrReceive">
                    <div
                      className="customDropdown"
                      onClick={() => setTypeDropdownOpen(!typeDropdownOpen)}
                    >
                      {defaultTypeText}
                      <IoIosArrowDropdown className="dropdownIcon" />
                      <span>{transactionType}</span>
                      {typeDropdownOpen && (
                        <ul className="dropdownOptions">
                          <li
                            onClick={() => {
                              setDefaultTypeText(""); // Clear the default text
                              setTransactionType("Give");
                            }}
                          >
                            Give
                          </li>
                          <li
                            onClick={() => {
                              setDefaultTypeText(""); // Clear the default text
                              setTransactionType("Receive");
                            }}
                          >
                            Receive
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>

                  <div className="itemOrCurrency">
                    <div
                      className="customDropdown"
                      onClick={() => setGiftDropdownOpen(!giftDropdownOpen)}
                    >
                      {defaultGiftText}
                      <IoIosArrowDropdown className="dropdownIcon" />
                      <span>{selectionType}</span>
                      {giftDropdownOpen && (
                        <ul className="dropdownOptions">
                          <li
                            onClick={() => {
                              setDefaultGiftText(""); // Clear the default text
                              setSelectionType("Item");
                              setQuantity(1); // reset quantity to 1 when selecting
                              toggleGift();
                            }}
                          >
                            Item
                          </li>
                          <li
                            onClick={() => {
                              setDefaultGiftText(""); // Clear the default text
                              setSelectionType("Currency");
                              toggleAmounts();
                            }}
                          >
                            Currency
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                  {details && isModalOpen && (
                    <SharePostModal
                      isOpen={isModalOpen}
                      closeModal={() => setIsModalOpen(false)}
                      details={details}
                      // generatedLink={generatedLink}
                      // linkGenerated={linkGenerated}
                    />
                  )}
                </div>
                <div className="bottom-row-container">
                  {/* quantity of currency gifts */}
                  {selectionType === "Currency" &&
                    transactionType === "Give" && (
                      <div className="numberInputContainer">
                        <label htmlFor="quantity"></label>
                        <input
                          type="number"
                          id="quantity"
                          name="quantity"
                          value={quantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "") {
                              setQuantity(""); // Allow empty string when input is cleared
                            } else {
                              setQuantity(Number(value)); // Set the number when there is a value
                            }
                          }}
                          min="1"
                          step="1"
                          placeholder="Quantity"
                        />
                      </div>
                    )}
                </div>
              </div>
              <div className="instructions-middle-card">
                <p>
                  Creating a link will adjust your account balance. Unused links
                  will refund the balance after 24 hours.
                </p>
              </div>
              
              {/* conditionally render submit or add funds button */}
              {transactionType && selectionType && 
                <div className="shareButtonContainer">
                  {(balance >= totalCost || transactionType === "Receive") && (
                    <button className="shareButton" type="submit">
                      Create
                    </button>
                  )}
                  {(balance < totalCost && transactionType === "Give") && (
                    <button 
                      className="green-shareButton" 
                      type="button" // prevents form submission
                      onClick={goToAddFunds}>
                      Add Funds
                    </button>
                  )}
                </div>
              }
             
            </form>
          </div>
        </div>
      </div>
      </>
      )} 
      {/* upscaling for downloaded images */}
        <ImageProcessor
            username={user.username}
            details={details}
            trigger={triggerImageProcessor}
            setTriggerImageProcessor={setTriggerImageProcessor}
            onDoneProcessing={handleProcessingComplete}
          />
    </div>
  );
}

Share.propTypes = {
  setIsAccountBalanceModalOpen: propTypes.func,
  setShowTopbar: propTypes.func,
};